import { Attachment, L10N, Listing, Localization } from '@smg-real-estate/hg-rets-schema';

import { getListingDefaultLocale } from '@/helpers/ListingData/ListingData';
import { isPlatformIs24 } from '@/helpers/platformDetection';

const HG_MEDIA_DOMAIN = 'media2.homegate.ch';
const IS24_MEDIA_DOMAIN = 'cdn.immoscout24.ch';

export const parsePlatformSpecificMediaURL = (imageURL: string | undefined): string | undefined => {
  if (isPlatformIs24() && imageURL?.includes(HG_MEDIA_DOMAIN)) {
    return imageURL.replace(new RegExp(HG_MEDIA_DOMAIN, 'i'), IS24_MEDIA_DOMAIN);
  }
  return imageURL;
};

export const getListingWithPlatformSpecificMediaURLs = (listing: Listing): Listing => {
  if (isPlatformIs24()) {
    const defaultLocale = getListingDefaultLocale(listing);

    const parsedLocale: L10N | undefined = {
      ...defaultLocale,
      attachments: defaultLocale?.attachments?.map((attachment: Attachment) => ({
        ...attachment,
        url: parsePlatformSpecificMediaURL(attachment.url),
      })),
    };

    const localization: Localization | undefined = {
      ...listing.localization,
      [listing.localization?.primary || 'de']: parsedLocale,
    };

    return {
      ...listing,
      localization,
    };
  }
  return listing;
};
